module.exports = __webpack_public_path__ + "static/media/Alignment-red.82a57418.svg";